import * as yup from "yup";

// eslint-disable-next-line import/prefer-default-export
export const validationSchema = yup.object().shape({
    // personal info
    arabicName: yup
        .string()
        .matches(
            /^([\u0600-\u06FF]+\s){3,}[\u0600-\u06FF]+\s*$/,
            "Name must be at least 4 Arabic words"
        )
        .min(4)
        .required("Please fill this required field"),
    phoneNumber: yup
        .string()
        .matches(/^01[0-2,5]{1}[0-9]{8}$/, "Please enter a valid phone number")
        .required("Please fill this required field"),
    nationalId: yup.string().required("Please enter your national ID"),
    email: yup.string().email(),
    nationalIdFace: yup
        .array()
        .min(1, "Please upload your ID photo - face")
        .required("Please upload your ID photo - face"),
    nationalIdBack: yup
        .array()
        .min(1, "Please upload your ID photo - back")
        .required("Please upload your ID photo - back"),

    // working info
    supplierType: yup.object().required("Please choose your supplier type"),
    truckTypes: yup.array().required("Please choose your truck type"),
    workingGovernorates: yup.array().required("Please choose your working governorates"),

    // company info
    hasACompany: yup.object().required("Please fill this required field"),

    companyName: yup.string().when("hasACompany.label", {
        is: "Yes",
        then: () =>
            yup
                .string()
                .matches(/^[\u0600-\u06FF\s]+$/, "Name must be in Arabic")
                .required("Please enter your company name"),
        otherwise: () => yup.string().strip(),
    }),

    commercialRegistrationAttachments: yup.array().when("hasACompany.label", {
        is: "Yes",
        then: () =>
            yup
                .array()
                .min(1, "Please upload commercial registration")
                .required("Please upload your commercial registration"),
        otherwise: () => yup.array().strip(),
    }),
    taxCardAttachments: yup.array().when("hasACompany.label", {
        is: "Yes",
        then: () =>
            yup
                .array()
                .min(1, "Please upload your tax card")
                .required("Please enter your tax card"),
        otherwise: () => yup.array().strip(),
    }),

    // payment info
    paymentMethod: yup.object().required("Please choose your payment method"),
    accountHolderName: yup.string().required("Please enter bank holder name"),
    bankName: yup.object().when("paymentMethod.label", {
        is: "Bank Account",
        then: () => yup.object().required("Please enter your bank name"),
        otherwise: () => yup.object().strip(),
    }),
    bankAccountNumber: yup.string().when("paymentMethod.label", {
        is: "Bank Account",
        then: () =>
            yup
                .string()
                .matches(/^[0-9]+$/, "Please enter a number")
                .required("Please enter your bank number"),
        otherwise: () => yup.string().strip(),
    }),
    ibanNumber: yup.string().when("paymentMethod.label", {
        is: "Bank Account",
        then: () =>
            yup
                .string()
                .matches(/^[0-9]+$/, "Please enter a number")
                .required("Please enter your IBAN number"),
        otherwise: () => yup.string().strip(),
    }),
    eWalletName: yup.object().when("paymentMethod.label", {
        is: "E Wallet",
        then: () => yup.object().required("Please choose your E-wallet name"),
        otherwise: () => yup.object().strip(),
    }),
    eWalletNumber: yup.string().when("paymentMethod.label", {
        is: "E Wallet",
        then: () =>
            yup
                .string()
                .matches(/^01[0-2,5]{1}[0-9]{8}$/, "Please enter a valid phone number")
                .required("Please enter your E-wallet number"),
        otherwise: () => yup.string().strip(),
    }),
    mezzaCardName: yup.object().when("paymentMethod.label", {
        is: "Mezza Card",
        then: () => yup.object().required("Please choose your bank name"),
        otherwise: () => yup.object().strip(),
    }),
    meezaCardNumber: yup.string().when("paymentMethod.label", {
        is: "Mezza Card",
        then: () =>
            yup
                .string("Please enter your mezza card number")
                .matches(/^\d{16}$/, "Mezza Card number must be exactly 16 digits")
                .required("Please enter your mezza card number"),
        otherwise: () => yup.string().strip(),
    }),
    organizationId: yup.object().notRequired(),
});
